'use client';

import { useContext } from 'react';

import { PermissionContext } from './PermissionProvider';
import type { PermissionContextValue } from './types';

export function usePermissions(): PermissionContextValue {
  return useContext(PermissionContext);
}
